import { render } from "./AppOverlay.vue?vue&type=template&id=ba1c96ea&scoped=true"
import script from "./AppOverlay.vue?vue&type=script&lang=js"
export * from "./AppOverlay.vue?vue&type=script&lang=js"

import "./AppOverlay.vue?vue&type=style&index=0&id=ba1c96ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1c96ea"]])

export default __exports__